<app-collections-multilevel-chart
  [showProgressBar]="showProgressBar"
  [variables]="variables"
  [showVariableMenu]="true"
  [page]="currentPage"
  [data]="collectionsMultiLevel"
  [benchmarkPercentile]="benchmarkPercentile"
  [activeVarianceToggle]="activeVarianceToggle"
  [sortingCriteria]="varianceToggleSortingCriterion"
  [tabLevel]="3"
  [columnSelectionCallback]="whenProviderSelected">
</app-collections-multilevel-chart>
<app-data-table id="collections-data-table"
                [rowSelectionCallback]="whenProviderSelected"
                [showProgressBar]="showProgressBar"
                [receivedData]="collectionsMultiLevel"
                [tableCssClass]="'collection-table'"
                [displayedColumns]="displayedColumns"
                [defaultSortColumn]="defaultSortColumn"
                [showLevel]="false"
                [shouldPutNullsAtTheBottom]="activeVarianceToggle"
                [sortingDataAccessor]="sortingDataAccessor"
                [sortDirection]="sortDirection"
                tableTitle="Collection Analysis By Provider"
                [whenSortChanged]="levelSpecificHandleSortChange"
                [collectionsTab]="true"
                [originalColumns]="columns"
                [displayZeroSuppression]="true"
                [zeroSuppressionCondition]="zeroSuppressCondition"
                [countOfSuppressedEntries]="countOfSuppressedEntries"
                [zeroSuppressionSnapshotEntry]="countOfSuppressedEntries > 1 || countOfSuppressedEntries === 0 ?
                 'Providers' : 'Provider'"
                [isZeroSuppressionChecked]="isZeroSuppressed"
                [currentPage]="currentPage"
                [updateSortingCriteria]="updateSortingCriteria"
                [addRemoveOption]="true"
                [reducerAction]="reducerAction"
>
</app-data-table>
